const TOKEN = "bearerToken";

export const retrieveTokens = () => {
  const token = localStorage.getItem(TOKEN);
  if (!token) {
    return null;
  }

  const tokenContent = parseJwt(token);
  if (Date.now() > tokenContent.exp * 1000) {
    clearTokens();
    return null;
  }

  const municipal_utility_id = parseMunicipalUtilityId(tokenContent.scopes[0]);

  return {
    [TOKEN]: token,
    username: tokenContent?.sub,
    municipal: municipal_utility_id,
  };
};

export const storeTokens = (token) => {
  localStorage.setItem(TOKEN, token);
};

export const clearTokens = () => {
  localStorage.removeItem(TOKEN);
};

/**
 * Load data from JWT token.
 *
 * See https://stackoverflow.com/a/38552302
 */
export function parseJwt(token) {
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split("")
      .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
      .join("")
  );
  return JSON.parse(jsonPayload);
}

// Helper function to extract the id of the municipal from the scopes attribute of the token
// the scopes variable of tokenContent is an array, and since we have a very simple permission system
// either an admin or a municipal unity user, it has the following two possible values:
// either 'admin' or 'municipal:<id>', the id represent the id in the db of the given municipal
export function parseMunicipalUtilityId(scope) {
  if (scope !== "admin") {
    return Number(scope.split(":")[1]);
  } else {
    return null;
  }
}
